/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月01日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
	//账套管理
	accountSets: {
		list(params = {}) {
			return Ajax.get("/account-sets", params)
		},
		load(id) {
			return Ajax.get(`/account-sets/${id}`)
		},
		users(params = {}) {
			return Ajax.get(`/account-sets/users`, params)
		},
		status(params = {}) {
			return Ajax.post(`/account-sets/status`, Qs.stringify(params))
		},
		//使用续订代码为账套续费
		renew(params = {}) {
			return Ajax.post(`/account-sets/renew`, params)
		},
		//当前账套到期信息（到期提醒用）
		expireInfo() {
			return Ajax.get(`/account-sets/expireInfo`)
		},
		reset(params = {}) {
			return Ajax.post(`/account-sets/reset`, Qs.stringify(params))
		},
		//按最新准则模板补齐科目并重建标准报表
		upgradeStandard(params = {}) {
			return Ajax.post(`/account-sets/upgrade-standard`, Qs.stringify(params))
		},
		delete(id, smsCode, asid) {
			return Ajax.delete(`/account-sets/${id}/${smsCode}${asid != null ? `?asid=${asid}` : ''}`)
		},
		save(params = {}) {
			return Ajax.post(`/account-sets`, params)
		},
		addUser(params = {}) {
			return Ajax.get(`/account-sets/addUser`, params)
		},
		updateUserRole(params = {}) {
			return Ajax.get(`/account-sets/updateUserRole`, params)
		},
		addNewUser(params = {}) {
			return Ajax.get(`/account-sets/addNewUser`, params)
		},
		removeUser(uid, params = {}) {
			return Ajax.get(`/account-sets/removeUser/${uid}`, params)
		},
		checkUse(asid) {
			return Ajax.get(`/account-sets/checkUse`, {asid})
		},
		update(params = {}) {
			return Ajax.put(`/account-sets`, params)
		},
		identification(params = {}) {
			return Ajax.post(`/account-sets/identification`, Qs.stringify(params))
		},
		handOver(params = {}) {
			return Ajax.post(`/account-sets/handOver`, Qs.stringify(params))
		},
		updateEncode(params = {}) {
			return Ajax.post(`/account-sets/updateEncode`, Qs.stringify(params))
		}
	},
	//凭证字
	voucherWord: {
		list() {
			return Ajax.get("/voucher-word")
		},
		load(id) {
			return Ajax.get(`/voucher-word/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/voucher-word/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/voucher-word`, params)
		},
		update(params = {}) {
			return Ajax.put(`/voucher-word`, params)
		}
	},
	//币别
	currency: {
		list() {
			return Ajax.get("/currency")
		},
		load(id) {
			return Ajax.get(`/currency/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/currency/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/currency`, params)
		},
		update(params = {}) {
			return Ajax.put(`/currency`, params)
		}
	},
	//科目
	subject: {
		list(type) {
			return Ajax.get("/subject?type=" + type)
		},
		allList() {
			return Ajax.get("/subject")
		},
		load(id) {
			return Ajax.get(`/subject/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/subject/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/subject`, params)
		},
		update(params = {}) {
			return Ajax.put(`/subject`, params)
		},
		voucherSelect(params = {}) {
			return Ajax.get(`/subject/voucher/select`, params)
		},
		loadByCode(code = [], checkData = {}) {
			return Ajax.post(`/subject/loadByCode`, Qs.stringify(Object.assign(checkData, {code: code.filter(v => !!v)}), {indices: false}))
		},
		checkUse(id) {
			return Ajax.get(`/subject/checkUse/${id}`)
		},
		balance(params = {}) {
			return Ajax.get(`/subject/balance`, params)
		},
		import(params) {
			return Ajax.post(`/subject/import`, params, {'Content-Type': 'multipart/form-data'})
		},
		merge(params = {}) {
			return Ajax.post(`/subject/merge`, Qs.stringify(params))
		},
		exportUrl(type) {
			return `/api/subject/export?type=${encodeURIComponent(type)}`
		},
		batchDelete(ids) {
			return Ajax.post(`/subject/batch/delete`, Qs.stringify({ids: ids}, {indices: false}))
		},
		batchAuxiliary(ids, auxiliaryAccounting) {
			return Ajax.post(`/subject/batch/auxiliary`, Qs.stringify({ids: ids, auxiliaryAccounting: auxiliaryAccounting || ''}, {indices: false}))
		},
		disableChildren(ids) {
			return Ajax.post(`/subject/batch/disableChildren`, Qs.stringify({ids: ids}, {indices: false}))
		},
		cashFlowItems() {
			return Ajax.get(`/subject/cashFlow/items`)
		},
		setCashFlowItem(id, itemId) {
			let params = itemId ? {itemId: itemId} : {};
			return Ajax.post(`/subject/cashFlow/${id}`, Qs.stringify(params))
		}
	},
	//科目
	initialBalance: {
		list(type) {
			return Ajax.get("/initial-balance?type=" + type)
		},
		load(id) {
			return Ajax.get(`/initial-balance/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/initial-balance/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/initial-balance`, params)
		},
		update(params = {}) {
			return Ajax.put(`/initial-balance`, params)
		},
		trialBalance() {
			return Ajax.get(`/initial-balance/trialBalance`)
		},
		saveAuxiliary(params) {
			return Ajax.post(`/initial-balance/auxiliary`, params)
		},
		templateUrl() {
			return `/api/initial-balance/template`
		},
		exportUrl(type) {
			return `/api/initial-balance/export?type=${encodeURIComponent(type)}`
		},
		importExcel(params) {
			return Ajax.post(`/initial-balance/import`, params, {'Content-Type': 'multipart/form-data'})
		},
		clear() {
			return Ajax.delete(`/initial-balance/clear`)
		},
		cashFlowItems() {
			return Ajax.get(`/initial-balance/cashFlow/items`)
		},
		saveCashFlow(params = {}) {
			return Ajax.post(`/initial-balance/cashFlow/save`, params)
		}
	},
	//辅助核算类别
	accountingCategory: {
		list() {
			return Ajax.get("/accounting-category")
		},
		load(id) {
			return Ajax.get(`/accounting-category/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/accounting-category/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/accounting-category`, params)
		},
		update(params = {}) {
			return Ajax.put(`/accounting-category`, params)
		},
		import(params) {
			return Ajax.post(`/accounting-category/import`, params, {'Content-Type': 'multipart/form-data'})
		}
	},
	accountingCategoryDetails: {
		list(categoryId, params = {}) {
			return Ajax.get(`/accounting-category-details?accounting_category_id=${categoryId}`, params)
		},
		load(id) {
			return Ajax.get(`/accounting-category-details/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/accounting-category-details/${id}`)
		},
		clearData(id) {
			return Ajax.delete(`/accounting-category-details/clear/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/accounting-category-details`, params)
		},
		update(params = {}) {
			return Ajax.put(`/accounting-category-details`, params)
		},
		loadAuxiliaryAccountingData(params) {
			return Ajax.post(`/accounting-category-details/loadAuxiliaryAccountingData`, params)
		}
	},
	//用户
	user: {
		list() {
			return Ajax.get("/user")
		},
		load(id) {
			return Ajax.get(`/user/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/user/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/user`, params)
		},
		update(params = {}) {
			return Ajax.put(`/user`, params)
		}
	},
	//模板
	voucherTemplate: {
		list() {
			return Ajax.get("/voucher-template")
		},
		load(id) {
			return Ajax.get(`/voucher-template/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/voucher-template/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/voucher-template`, params)
		},
		update(params = {}) {
			return Ajax.put(`/voucher-template`, params)
		}
	},
	organization: {
		mapping(list) {
			return Ajax.post('/inventory/organization/mapping', list);
		}
	},
	Inventory: {
		order(params) {
			return Ajax.get('/inventory/order', params);
		},
		orderDetail(id) {
			return Ajax.get(`/inventory/orderDetail/${id}`);
		},
		org() {
			return Ajax.get('/inventory/org');
		},
		material() {
			return Ajax.get('/inventory/material');
		},
		supplier() {
			return Ajax.get('/inventory/supplier');
		},
		getMaterialMapping() {
			return Ajax.get('/inventory/getMaterialMapping');
		},
		materialMapping(list) {
			return Ajax.post('/inventory/materialMapping', list);
		},
		getSupplierMapping() {
			return Ajax.get('/inventory/getSupplierMapping');
		},
		supplierMapping(list) {
			return Ajax.post('/inventory/supplierMapping', list);
		}
	},
	inventoryMaterial: {
		list(params = {}) {
			return Ajax.get('/inventory-material', params)
		},
		save(p) {
			return Ajax.post('/inventory-material', p)
		},
		update(p) {
			return Ajax.put('/inventory-material', p)
		},
		delete(id) {
			return Ajax.delete(`/inventory-material/${id}`)
		}
	},
	inventorySupplier: {
		list(params = {}) {
			return Ajax.get('/inventory-supplier', params)
		},
		save(p) {
			return Ajax.post('/inventory-supplier', p)
		},
		update(p) {
			return Ajax.put('/inventory-supplier', p)
		},
		delete(id) {
			return Ajax.delete(`/inventory-supplier/${id}`)
		}
	},
	inventoryOrder: {
		list(params = {}) {
			return Ajax.get('/inventory-order', params)
		},
		load(id) {
			return Ajax.get(`/inventory-order/${id}`)
		},
		save(p) {
			return Ajax.post('/inventory-order', p)
		},
		delete(id) {
			return Ajax.delete(`/inventory-order/${id}`)
		},
		preview(ids) {
			return Ajax.post('/inventory-order/preview', {ids})
		},
		generate(ids) {
			return Ajax.post('/inventory-order/generate', {ids})
		}
	},
	//税务信息（电子税局配置与账号）
	taxAccount: {
		panel(params = {}) {
			return Ajax.get('/tax-account/panel', params)
		},
		saveConfig(p) {
			return Ajax.post('/tax-account/config', p)
		},
		save(p) {
			return Ajax.post('/tax-account', p)
		},
		setDefault(params = {}) {
			return Ajax.get('/tax-account/default', params)
		},
		delete(id, params = {}) {
			return Ajax.delete(`/tax-account/${id}${params.asid != null ? `?asid=${params.asid}` : ''}`)
		}
	},
	//账套参数中心
	setsSettings: {
		get() {
			return Ajax.get('/sets-settings')
		},
		save(params = {}) {
			return Ajax.post('/sets-settings', params)
		},
		history() {
			return Ajax.get('/sets-settings/history')
		},
		rollback(historyId) {
			return Ajax.post('/sets-settings/rollback', Qs.stringify({historyId}))
		}
	},
	//角色权限
	role: {
		list() {
			return Ajax.get('/role')
		},
		save(params = {}) {
			return Ajax.post('/role', params)
		},
		update(params = {}) {
			return Ajax.put('/role', params)
		},
		copy(sourceAsid) {
			return Ajax.post('/role/copy', Qs.stringify({sourceAsid}))
		},
		delete(id) {
			return Ajax.delete(`/role/${id}`)
		}
	},
	//期间汇率
	exchangeRate: {
		list() {
			return Ajax.get('/exchange-rate')
		},
		save(params = {}) {
			return Ajax.post('/exchange-rate', params)
		},
		delete(id) {
			return Ajax.delete(`/exchange-rate/${id}`)
		},
		carry(params = {}) {
			return Ajax.post('/exchange-rate/carry', Qs.stringify(params))
		}
	}
}
